import { render } from "./SurveyDetailsDashboard.vue?vue&type=template&id=210b9338"
import script from "./SurveyDetailsDashboard.vue?vue&type=script&lang=js"
export * from "./SurveyDetailsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__